module.exports = __webpack_public_path__ + "img/tellertobranch.fw.d9b7cdda.png";